import axios from 'axios';
import {api, apiBaseUrl, appUrl} from '#constants/appUrl';


const authRepository = {
    state: {
      authenticated: false,
      user: {},
      permissions: []
    },
    mutations: {
      setAuthenticated(state, value) {
        state.authenticated = value
      },
      setUser(state, value) {
        state.user = value
      },
      setPermissions(state, value) {
        state.permissions = value
      }
    },
    actions: {
        async signIn({dispatch, commit}, loginForm) {

          return await axios.post(api + 'login', loginForm).then((response) => {
            sessionStorage.setItem('token', response.data.token);
          }).then(() => {
            return dispatch('login');
          }).catch((error) => {
            throw error.response.data.errors;
          })
          
        },
        async login({commit}) {
            let token = sessionStorage.getItem('token')
            return await axios.get('/api/user', {
                headers: {
                  'accept': 'application/json',
                  'Authorization': 'Bearer ' + token
                }
            }).then((response) => {

              sessionStorage.setItem('user', JSON.stringify(response.data.user))

              let user = JSON.parse(sessionStorage.getItem('user'))
              let roles = user.roles

              if (roles.includes('municipe') && roles.length === 1) {
                sessionStorage.removeItem('token')
                sessionStorage.removeItem('user')
                commit('setErrors', {
                  username: ['Usuário inválido']
                })
              } else {
                window.location.href = "/services-inbox"
              }

            }).catch((error) => {
              commit('setErrors', error.response.data.errors)
            })
        },
        changePasswordAfterRegistration({commit}, data) {
            return new Promise((resolve, reject) => {
                axios.post(`${api}change-password/${data.id}`, data, {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                    }
                }).then((response) => {
                    resolve(response)
                }).catch((error) => {
                    error.response.data.errors ? commit('setErrors', error.response.data.errors) : commit('setErrors', error.response.data)
                    reject(error)
                })
            })
        },
        issueUser({commit}) {
            return new Promise((resolve, reject) => {
                let token = sessionStorage.getItem('token')
                axios.get('/api/user', {
                    headers: {
                        'Authorization': 'Bearer ' + token
                    }
                }).then((response) => {
                    sessionStorage.removeItem('user', JSON.stringify(response.data.user))
                    sessionStorage.setItem('user', JSON.stringify(response.data.user))
                    resolve(response)
                }).catch((error) => {
                    reject(error)
                })
            })
        },
        logout({commit}) {
            let token = sessionStorage.getItem('token')
            axios.post(api + 'logout', {}, {
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Accept': 'application/json'
                }
            }).then(() => {
                sessionStorage.removeItem('token')
                sessionStorage.removeItem('user')
                window.location.reload()
            })

        },
        setUser({commit}) {
            let user = JSON.parse(sessionStorage.getItem('user'))
            commit('setUser', user)
        },
        setPermissions({commit}) {
            let user = JSON.parse(sessionStorage.getItem('user'))
            commit('setPermissions', user.permissions)
        }
    },
    getters: {
        authenticated(state) {
            return state.authenticated
        },
        user(state) {
            return state.user
        }
    }
}


export default authRepository;
